import { render, staticRenderFns } from "./DealExpand.vue?vue&type=template&id=714b4416&scoped=true&"
import script from "./DealExpand.vue?vue&type=script&lang=js&"
export * from "./DealExpand.vue?vue&type=script&lang=js&"
import style0 from "./DealExpand.vue?vue&type=style&index=0&id=714b4416&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714b4416",
  null
  
)

export default component.exports